import styled from 'styled-components'

export const Container = styled.section`
    float: left;
    width: 100%;
    padding: 20px 30px;
    background-color: #F09C00;
    display: flex;
    align-items: center;
    justify-content: center;

    @media (max-width: 900px) {
        flex-direction: column;
        padding: 20px;
    }
`

export const Texto = styled.span`
    text-align: center;
    color: #000;
    font-size: 22px;
    line-height: 22px;
    font-weight: 900;
    margin-right: 20px;

    @media (max-width: 900px) {
        font-size: 15px;
        line-height: 25px;
        margin-right: 0;
        margin-bottom: 10px;
    }
`

export const Row = styled.div`
    display: flex;

    @media (max-width: 900px) {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 5px;
        width: 100%;
    }
`

export const Column = styled.div`
    width: 70px;
    border: solid 1px #000;
    border-radius: 4px;
    text-align: center;
    position: relative;
    padding: 5px 0;

    + div {
        margin-left: 7px;
    }

    @media (max-width: 900px) {
        width: auto;

        + div {
            margin-left: 0;
        }
    }

`

export const Time = styled.div`
    font-size: 26px;
    margin-bottom: 0;
    font-weight: 900;
    color: #000;

    @media (max-width: 600px) {
        font-size: 20px;
    }
`

export const Label = styled.div`
    font-size: 11px;
    color: #000;

    @media (max-width: 650px) {
        font-size: 10px;
    }
`